import React from 'react';
import { Button } from './ui/button';
import { RefreshCw, AlertTriangle } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorCount: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App error:', error, errorInfo);
    // Auto-clear stale data that causes persistent crashes
    try {
      localStorage.removeItem('salon_user');
    } catch (e) {
      // localStorage might not be available
    }
  }

  handleRefresh = () => {
    // Clear all app data to ensure fresh state
    try {
      localStorage.removeItem('salon_user');
    } catch (e) {
      // ignore
    }
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-slate-800 mb-2">Something went wrong</h2>
            <p className="text-slate-500 mb-6">The page encountered an error. Your session has been reset.</p>
            <Button onClick={this.handleRefresh} className="bg-[#1e1e3f] hover:bg-[#2d2d5a] text-white rounded-xl px-6">
              <RefreshCw className="w-4 h-4 mr-2" />
              Back to Login
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
